import { Form, Row, Col, Button } from "react-bootstrap"
import BreadcrumbDatos from "./BreadcrumbDatos";
import { useNavigate, useParams } from "react-router-dom"
import { useState, useEffect } from "react";
import ProvinciasSelect from "../common/ProvinciaSelect";
import EstadoSelect from "../common/EstadoSelect";
import { useForm } from "react-hook-form";
import { nuevoCliente, getCliente, editarCliente } from "../../services/ClientesService";
import ErrorMessages from "../common/ErrorMessages";

export default function ClientesForm() {

    /*
    https://www.react-hook-form.com/get-started/
    */

    const {id} = useParams();

    const navigate = useNavigate();

    const [errores, setErrores] = useState([]);

    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    useEffect(() => {
        const iniciarEdicion = async () => {
            let resp = await getCliente(id);
            if (resp.error) {
                setErrores([resp.message]);
            } else {
                reset(resp.data);
            }
        }
        if (id) {
            iniciarEdicion();
        }
    }, [id,reset])

    function beforeSubmit() {
        setErrores([]);
    }

    const onSubmit = async (data) => {
        setErrores([]);
        let resp;
        if (id) {
            resp = await editarCliente(id, data);
        } else {
            resp = await nuevoCliente(data);
        }
        if (resp.error) {
            setErrores(resp.messages);
            window.scrollTo(0,0);
            /*for (let i=0;i<resp.messages.length;i++) {
                alert(resp.messages[i]);
            }*/
        } else {
            //setError("");
            alert("Cliente guardado correctamente");
            volver();
        }
    }

    function volver() {
        navigate("/clientes");
    }

    return <>
        <BreadcrumbDatos active="Clientes - Nuevo" />
        <ErrorMessages mensajes={errores} />
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Cuit
                </Form.Label>
                <Col sm="4">
                    <Form.Control 
                        id="cuit" 
                        {...register("cuit", {required:true, maxLength:11})} 
                        type="number" htmlSize="11" />
                </Col>
                {errors.cuit?.type === 'required' && <Col className="validacion error"><p role="alert">Cuit es requerido.</p></Col>}
                {errors.cuit?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 11 números para Cuit.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Nombre / Razón Social
                </Form.Label>
                <Col sm="8">
                    <Form.Control 
                        id="nombre_razon_social" 
                        {...register("nombre_razon_social", {required:true, maxLength:100})}
                        type="text" />
                </Col>
                {errors.nombre_razon_social?.type === 'required' && <Col className="validacion error"><p role="alert">Nombre es requerido.</p></Col>}
                {errors.nombre_razon_social?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 100 caracteres para Nombre.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Teléfono
                </Form.Label>
                <Col sm="4">
                    <Form.Control 
                        id="telefono" 
                        {...register("telefono", {required:true, maxLength:30})}
                        type="text" htmlSize="11"/>
                </Col>
                {errors.telefono?.type === 'required' && <Col className="validacion error"><p role="alert">Teléfono es requerido.</p></Col>}
                {errors.telefono?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 30 caracteres para Teléfono.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Domicilio
                </Form.Label>
                <Col sm="8">
                    <Form.Control 
                        id="domicilio" 
                        {...register("domicilio", {maxLength:150})}
                        type="text" />
                </Col>
                {errors.domicilio?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 150 caracteres para Domicilio.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Ciudad
                </Form.Label>
                <Col sm="8">
                    <Form.Control 
                        id="ciudad" 
                        {...register("ciudad", {maxLength:100})}
                        type="text" />
                </Col>
                {errors.ciudad?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 100 caracteres para Ciudad.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Provincia
                </Form.Label>
                <Col sm="8">
                    <ProvinciasSelect register={register} name="provincia" />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Email
                </Form.Label>
                <Col sm="8">
                    <Form.Control 
                        id="email" 
                        {...register("email", {required:true, maxLength:100, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i})}
                        type="text" />
                </Col>
                {errors.email?.type === 'required' && <Col className="validacion error"><p role="alert">Email es requerido.</p></Col>}
                {errors.email?.type === 'pattern' && <Col className="validacion error"><p role="alert">Email inválido.</p></Col>}
                {errors.email?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 100 caracteres para Email.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Color
                </Form.Label>
                <Col sm="3">
                    <Form.Control 
                        id="color" 
                        defaultValue="#000000"
                        {...register("color", {required:true})} 
                        type="color" />
                </Col>
                {errors.color?.type === 'required' && <Col className="validacion error"><p role="alert">Color es requerido.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Estado
                </Form.Label>
                <Col sm="3">
                    <EstadoSelect register={register} name="estado"/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Col>
                    <Button onClick={beforeSubmit} type="submit">Guardar</Button>
                    <Button variant="secondary" onClick={volver}>Cancelar</Button>
                </Col>
            </Form.Group>
        </Form>
    </>

}